// libs
import React, { useEffect } from 'react';
import { withDataFetching } from 'shared/helpers/dataFetching';
import { RouteComponentProps, withRouter } from 'react-router';
import isEmpty from 'lodash/isEmpty';
// redux actions
import { fetchPDPData as _fetchPDPData } from 'shared/store/details/services';
import { updateStatusCode as _updateStatusCode } from 'shared/store/app/actions';
import { resetErrorSku as _resetErrorSku } from 'shared/store/details/actions';

// helpers
import { isSKUChanged } from './helpers';
import { buildStoreRedirectId } from 'shared/helpers/storeUrl';
import { getPincodeFromStorage } from '../components/ProductInfo/storage';

interface IApiProps extends RouteComponentProps<{ id?: string; sku?: string; }, {}> {
  children: React.ReactNode;
  productSKU?: string;
  productID?: string;
  fetchPDPData: typeof _fetchPDPData;
  ssrHeaders: { [key: string]: string; };
  cookies: { [key: string]: string; };
  updateStatusCode: typeof _updateStatusCode;
  errorSKU: string;
  isFetching: boolean;
  fetchingSKU: string;
  videoEnabled: boolean;
  videoPosition: number;
  isMobile: boolean;
  isPriceReveal: boolean;
  reset?: typeof _resetErrorSku;
  isEddV2Enabled?: boolean;
  storeId: string;
  isMultiSellerEligible: boolean;
}

function DetailApi({ children, reset }: IApiProps) {
  useEffect(() => {
    return reset;
  }, [reset]);
  return <>{children}</>;
}

const fetchData = async ({
  productSKU,
  productID,
  fetchPDPData,
  match,
  location,
  ssrHeaders,
  cookies,
  updateStatusCode,
  errorSKU,
  isFetching,
  fetchingSKU,
  isMobile,
  isPriceReveal = false,
  isEddV2Enabled = false,
  storeId,
  isMultiSellerEligible,
}: IApiProps) => {
  const { url, params } = match;
  const { search } = location;
  const { sku: unSafeSKU, id: unSafeId } = params;
  const routeSKU = unSafeSKU && escape(unSafeSKU);
  const routeID = unSafeId && escape(unSafeId);

  const searchParams = new URLSearchParams(search);

  let skuId: string | undefined = undefined;
  if (searchParams.has('skuId')) {
    skuId = searchParams.get('skuId') || undefined;
  }

  const routeProductID = routeSKU || routeID;

  if (isFetching && fetchingSKU === routeProductID) {
    return;
  }

  if (
    isSKUChanged({ routeSKU, routeID, productID, productSKU }) &&
    (isEmpty(errorSKU) || errorSKU !== routeProductID)
  ) {
    const isOldURL = routeID !== undefined;
    const headers = __SERVER__ ? ssrHeaders : {};

    // @ts-ignore ...
    return fetchPDPData({
      productID: routeProductID,
      isNew: isOldURL,
      headers,
      incomingURL: url,
      searchParams: search,
      skuId,
      isMobile,
      isPriceReveal,
      isEddV2Enabled,
      catalog_tag_filter: buildStoreRedirectId(storeId),
      pincode: isMultiSellerEligible
        ? __SERVER__
          ? cookies?.pinCodeDel || undefined
          : getPincodeFromStorage() || undefined
        : undefined,
    }).catch((err: { status: number; }) => {
      if (err.status === 404) {
        updateStatusCode(404);
      } else {
        updateStatusCode(500);
      }
    });
  }
};

export default withRouter(withDataFetching(fetchData, { onUpdate: true })(DetailApi));
